document.addEventListener("DOMContentLoaded", function () {
  //============ START : Review Append Js Pdp Page ===================================
    const ratingsBlock = document.querySelector('reviewsio-product-ratings');
    const titlePriceContainer = document.querySelector('.product__title_price.flex.justify-between.items-center.mobile');

    const placeholder = document.createComment('original-rating-location');
    let hasMoved = false;

    function handleResponsiveRating() {
      const currentSnippet = document.querySelector('.ruk_rating_snippet');
      if (!ratingsBlock || !titlePriceContainer || !currentSnippet) return;

      // MOBILE: Move rating below title/price
      if (window.innerWidth <= 767 && !hasMoved) {
        if (currentSnippet.parentNode === ratingsBlock) {
          ratingsBlock.insertBefore(placeholder, currentSnippet);
          currentSnippet.remove();
          titlePriceContainer.insertAdjacentElement('afterend', currentSnippet);
          hasMoved = true;
        }
      }

      // DESKTOP: Move rating back to original
      if (window.innerWidth >= 768 && hasMoved) {
        currentSnippet.remove();
        placeholder.parentNode.insertBefore(currentSnippet, placeholder);
        hasMoved = false;
      }
    }

    // Run once on load
    handleResponsiveRating();

    // And on window resize
    window.addEventListener('resize', handleResponsiveRating);
  
  //============ END : Review Append Js Pdp Page ===================================

  //============ START: Thumbnail and main image height adjust =====================
   function adjustThumbnailHeight() {
    const mainImage = document.querySelector(".product__gallery .product__gallery-images");
    const thumbnails = document.querySelector(".product__gallery .product__gallery-thumbnails");
  
    if (!thumbnails) return;
  
    if (window.innerWidth > 767) {
      if (mainImage) {
        const mainImageHeight = mainImage.offsetHeight;
        if (mainImageHeight > 0) {
          thumbnails.style.height = `${mainImageHeight}px`;
        }
      }
    } else {
      // Reset height on mobile view
      thumbnails.style.height = "";
    }
  }
  
  // Run after DOM is ready
  adjustThumbnailHeight();
  
  // Run after full content including images is loaded
  window.addEventListener("load", adjustThumbnailHeight);
  
  // Run on resize
  window.addEventListener("resize", adjustThumbnailHeight);

  //============ START: Review slider button click event =====================
  document.querySelector(".review-button-wrapper .review-button").addEventListener("click", function () {
  
    const reviewsWidget = document.querySelector(".rio-withoutBranding");

    if (reviewsWidget) {
      // Scroll smoothly to the accordion header
      const offsetTop = reviewsWidget.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  });
  //============ END: Review slider button click event =====================

});
// $(document).ready(function () {
//   function adjustThumbnailHeight() {
//     if ($(window).width() > 767) {
//       var mainImageHeight = $(".product__gallery .product__gallery-images").outerHeight();
//       console.log("Main image height:", mainImageHeight);

//       if (mainImageHeight > 0) {
//         $(".product__gallery .product__gallery-thumbnails").css("height", mainImageHeight);
//       }
//     } else {
//       console.log("Screen ≤ 767px — resetting thumbnail height.");
//       $(".product__gallery .product__gallery-thumbnails").css("height", ""); 
//     }
//   }

//   // Run when DOM is ready
//   adjustThumbnailHeight();

//   // Run on window resize
//   $(window).on("resize", adjustThumbnailHeight);

//   // Optional: run again after images load
//   $(window).on("load", adjustThumbnailHeight);
// });


